/**
 * Login page with header and footer.
 */

import React from 'react';
import { useSearchParams } from 'react-router-dom';
import LoginForm from '../../components/auth/LoginForm';
import { PublicHeader, PublicFooter } from '../../components/public';

const Login = () => {
  const [searchParams] = useSearchParams();
  const transactionId = searchParams.get('transactionId');

  return (
    <div className="auth-page-layout">
      <PublicHeader />
      <main className="auth-page-main">
        <LoginForm transactionId={transactionId} />
      </main>
      <PublicFooter />
    </div>
  );
};

export default Login;
